import { FETCH_RELATED } from './constants'

export const fetchRelated = {
  request: (id, contentType, currentPhoneId) => ({
    type: FETCH_RELATED.REQUEST,
    id,
    contentType,
    currentPhoneId
  }),
  success: (related) => ({ type: FETCH_RELATED.SUCCESS, related }),
  failure: () => ({ type: FETCH_RELATED.FAILURE })
}
